import { render, staticRenderFns } from "./domain-metrics.vue?vue&type=template&id=259eb780"
import script from "./domain-metrics.vue?vue&type=script&lang=js"
export * from "./domain-metrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports